<template>
  <v-container>
    <v-flex class="flex">
      <v-layout>
        <v-card class="masterCard">
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>

          <v-data-table
            ref="table"
            :headers="headers"
            :items="forms"
            :items-per-page="5"
            :rows-per-page="20"
            :page="1"
            :loading="loading"
            :item-key="'code'"
            :search="search"
          >
            <template v-slot:item.controls="{ item }">
              <!--               <div>
                <vue-html2pdf
                  :paginate-elements-by-height="100"
                  :filename="stringNumber(item.id)"
                  :pdf-quality="2"
                  :show-layout="true"
                  pdf-content-width="100%"
                  :ref="'pdf' + item.code"
                  style="display: none"
                >
                  <section slot="pdf-content">
                    <reportVue :data="item" />
                  </section>
                </vue-html2pdf>
              </div> -->

              <!-- stop prop prevent to trigget the click row event -->
              <v-icon small class="mr-2" @click.stop="openReport(item)"
                >mdi-eye</v-icon
              >

              <v-icon small class="mr-2" @click.stop="downloadItem(item)"
                >mdi-download</v-icon
              >
            </template>
          </v-data-table>
        </v-card>
      </v-layout>
    </v-flex>
  </v-container>
</template>

<script>
/* import reportVue from "@/views/report.vue";
import VueHtml2pdf from "vue-html2pdf"; */
export default {
  data() {
    return {
      AuxDialog: false,
      edited: false,
      search: "",
      questions: [],
      questionsList: [],
      loading: true,
      headers: [
        {
          text: "ID",
          align: "start",
          value: "code",
        },
        {
          text: "Número de formulario",
          value: "id",
        },
        { text: "Nombre del R.A", value: "name" },
        {
          text: "Sector",
          value: "sector",
        },
        { text: "Institución", value: "org" },
        { text: "Fecha de creación", value: "date" },
        { text: "Fecha de actualización", value: "updateDate" },
        {
          text: "Técnico responsable de la validación",
          value: "responsable.userName",
        },
        { text: "Usuario", value: "user.userName" },
        { text: "Estatus", value: "status" },
        { text: "", value: "controls", width: "10%" },
      ],
    };
  },
  props: {
    forms: Array,
  },
  components: {
/*     reportVue,
    VueHtml2pdf, */
  },
  watch: {
    forms() {
      if (this.forms != undefined) {
        this.loading = false;
      }
    },
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  methods: {
    async downloadItem(item) {
      /* this.$refs["pdf" + item.code].generatePdf(); */
      try {
        const path = `/reporte/${item.code}#print`;
        window.open(path, "_blank");
      } catch (error) {
        console.log(error);
      }
    },
    stringNumber(number) {
      return number.toString();
    },
    openReport(item) {
      try {
        const path = `/reporte/${item.code}`;
        window.open(path, "_blank");
      } catch (error) {
        console.log(error);
      }
    },
  },
  async mounted() {},
};
</script>

<style scoped>
.masterCard {
  align-self: center;
  margin: 0 auto;
}

.flex {
  align-items: center;
  align-content: center;
  align-self: center;
}
</style>